import React, { useState, useEffect } from "react";
import slider1 from "../assets/images/slider/slider1.jpg";
import slider2 from "../assets/images/slider/slider2.jpg";
import slider3 from "../assets/images/slider/slider3.jpg";

function Home() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const slides = [
    { image: slider1, title: "워터피아 수영장" },
    { image: slider2, title: "실내 수영장" },
    { image: slider3, title: "야외 수영장" },
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 6000);

    return () => clearInterval(timer);
  }, [slides.length]);

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  return (
    <section id="home" className="relative h-screen min-h-[600px] overflow-hidden">
      {/* Background Slider */}
      <div className="absolute inset-0 z-0">
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`absolute inset-0 transition-all duration-[2000ms] ease-out-expo ${
              currentSlide === index ? "opacity-100 scale-105" : "opacity-0 scale-100"
            }`}
          >
            <div className="absolute inset-0 bg-slate-900/40 z-10" />
            <img
              src={slide.image}
              alt={slide.title}
              className="w-full h-full object-cover"
              loading={index === 0 ? "eager" : "lazy"}
            />
          </div>
        ))}
      </div>

      {/* Content Overlay */}
      <div className="relative z-20 h-full flex items-center justify-center px-6">
        <article className="max-w-4xl w-full text-center">
          <div className="inline-block px-4 py-1.5 mb-6 border border-white/30 rounded-full backdrop-blur-md">
            <span className="text-sm font-semibold text-blue-300 uppercase tracking-[0.2em]">
              Premium Pool Solutions
            </span>
          </div>

          <h1 className="text-3xl sm:text-5xl md:text-7xl lg:text-8xl font-black text-white mb-8 tracking-tighter leading-[1.1]">
            <span className="block opacity-90">새로운 공간의 완성,</span>
            <span className="bg-clip-text text-transparent bg-gradient-to-r from-blue-400 via-blue-200 to-white">
              워터피아가 함께합니다
            </span>
          </h1>

          <p className="text-lg md:text-xl text-slate-200 mb-12 max-w-2xl mx-auto leading-relaxed font-light">
            최고의 품질과 혁신적인 기술력으로 꿈꾸던 수영장을 현실로 만듭니다.
            <br className="hidden md:block" />
            고객의 만족을 넘어 감동을 드리는 수영장 전문기업입니다.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="tel:010-5113-4637"
              className="group relative px-8 py-4 bg-blue-600 text-white font-bold rounded-xl overflow-hidden transition-all duration-300 hover:bg-blue-700 hover:scale-105 premium-shadow"
            >
              <div className="relative z-10 flex items-center">
                <svg
                  className="w-5 h-5 mr-3 group-hover:animate-bounce"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2.5"
                    d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                  />
                </svg>
                전문가 상담하기
              </div>
            </a>
            <button
              onClick={() => document.getElementById("pool").scrollIntoView({ behavior: "smooth" })}
              className="px-8 py-4 bg-white/10 text-white font-bold rounded-xl backdrop-blur-md border border-white/20 transition-all duration-300 hover:bg-white/20"
            >
              포트폴리오 보기
            </button>
          </div>
        </article>
      </div>

      {/* Hero Navigation */}
      <div className="absolute bottom-12 left-0 right-0 z-30 flex justify-center items-center space-x-6">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => goToSlide(index)}
            className="group relative py-4"
            role="tab"
            aria-selected={currentSlide === index}
          >
            <div
              className={`w-12 h-1 rounded-full transition-all duration-500 overflow-hidden bg-white/20 ${currentSlide === index ? "w-20" : "group-hover:bg-white/40"}`}
            >
              <div
                className={`h-full bg-blue-500 transition-all duration-[6000ms] ease-linear ${
                  currentSlide === index ? "w-full" : "w-0"
                }`}
              />
            </div>
          </button>
        ))}
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-30 opacity-50 animate-bounce">
        <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 14l-7 7m0 0l-7-7m7 7V3" />
        </svg>
      </div>
    </section>
  );
}
export default Home;
